import Azimuth from '@/lib/azimuth'
import * as Constants from '@/lib/constants'
import i18n from '@/lib/i18n'
import UTCDateTime from '@/lib/utc-datetime'
import numeral from 'numeral'
import OpenWeatherMapClient from './open-weather-map-client'

export default class WeatherInfo {
  constructor() {
    this.main = undefined
    this.description = undefined
    this.iconUrl = undefined
    this.temperature = undefined
    this.temperatureUnit = undefined
    this.humidity = undefined
    this.humidityUnit = '%'
    this.pressure = undefined
    this.pressureUnit = 'hPa'
    this.windSpeed = undefined
    this.windSpeedUnit = undefined
    this.windDegree = undefined
    this.windDegreeDescription = undefined
    this.dt = undefined
    this.datetime = undefined
    this.sunrise = undefined
    this.sunset = undefined
    this.cloudiness = undefined
    this.cloudinessUnit = '%'
    this.rain3h = undefined
    this.rain3hUnit = 'mm'
  }

  /**
   * JSONシリアライズしたものからデシリアライズした際に、プレーンオブジェクトになっているものからの生成
   * {
   * "cloudiness": 40,
   * "cloudinessUnit": "%",
   * "datetime": "2017-11-01T06:30:00.000Z",
   * "description": "雲",
   * "humidity": 76,
   * "humidityUnit": "%",
   * "iconUrl": "http://openweathermap.org/img/w/03d.png",
   * "main": "Clouds",
   * "pressure": 1010,
   * "pressureUnit": "hPa",
   * "rain3hUnit": "mm",
   * "sunrise": "2017-10-31T21:09:09.000Z",
   * "sunset": "2017-11-01T07:26:58.000Z",
   * "temperature": 12.95,
   * "temperatureUnit": "&#8451;",
   * "windDegree": 130,
   * "windDegreeDescription": "南東",
   * "windSpeed": 2.1,
   * "windSpeedUnit": "m/s"
   * }
   */
  static fromJsonObject(jsonObject) {
    let w = new WeatherInfo()
    w.cloudiness = jsonObject.cloudiness
    w.cloudinessUnit = jsonObject.cloudinessUnit
    w.dt = jsonObject.dt
    w.datetime = UTCDateTime.toUtcMoment(jsonObject.datetime)
    w.description = jsonObject.description
    w.humidity = jsonObject.humidity
    w.humidityUnit = jsonObject.humidityUnit
    w.iconUrl = jsonObject.iconUrl
    w.main = jsonObject.main
    w.pressure = jsonObject.pressure
    w.pressureUnit = jsonObject.pressureUnit
    w.rain3h = jsonObject.rain3h
    w.rain3hUnit = jsonObject.rain3hUnit
    w.sunrise = UTCDateTime.toUtcMoment(jsonObject.sunrise)
    w.sunset = UTCDateTime.toUtcMoment(jsonObject.sunset)
    w.temperature = jsonObject.temperature
    w.temperatureUnit = jsonObject.temperatureUnit
    w.windDegree = jsonObject.windDegree
    w.windDegreeDescription = jsonObject.windDegreeDescription
    w.windSpeed = jsonObject.windSpeed
    w.windSpeedUnit = jsonObject.windSpeedUnit
    return w
  }

  static fromOpenWeatherMapResult(apiResult) {
    let w = new WeatherInfo()
    w.main = apiResult.weather[0].main
    w.description = apiResult.weather[0].description
    w.iconUrl = OpenWeatherMapClient.getWeatherIconUrl(apiResult.weather[0].icon)
    w.temperature = apiResult.main.temp
    w.temperatureUnit = OpenWeatherMapClient.getTemperatureUnit()
    w.humidity = apiResult.main.humidity
    w.pressure = apiResult.main.pressure
    w.windSpeed = apiResult.wind.speed
    w.windSpeedUnit = OpenWeatherMapClient.getWindSpeedUnit()
    w.windDegree = apiResult.wind.deg
    w.windDegreeDescription = Azimuth.toCompassDirection(apiResult.wind.deg, i18n.getUserLang())
    w.dt = apiResult.dt
    w.datetime = UTCDateTime.toUtcMoment(apiResult.dt)
    if (apiResult.sys.sunrise) {
      w.sunrise = UTCDateTime.toUtcMoment(apiResult.sys.sunrise)
    }
    if (apiResult.sys.sunset) {
      w.sunset = UTCDateTime.toUtcMoment(apiResult.sys.sunset)
    }
    w.cloudiness = apiResult.clouds.all
    if (apiResult.rain) {
      w.rain3h = apiResult.rain['3h']
    }
    return w
  }

  static getDatetimeStringAsDateTimeFormat(weatherInfo) {
    if (weatherInfo.datetime) {
      try {
        const datetime = weatherInfo.datetime.clone()
        return datetime.tz(Constants.DEFAULT_TIMEZONE).format('MM/DD HH:mm')
      } catch (e) {
        console.error(e)
      }
    }
    return undefined
  }

  static getTemperatureStringRounded(weatherInfo) {
    if (weatherInfo.temperature) {
      return numeral(weatherInfo.temperature).format('0.0')
    }
    return undefined
  }

  static getRain3hStringRounded(weatherInfo) {
    if (weatherInfo.rain3h) {
      return numeral(weatherInfo.rain3h).format('0.0')
    }
    return '0'
  }
}
